export class GeoObjectModel 
{
  geometry: any;
  properties: any;
  type: string;

  constructor() 
  {
  
  }
}
